import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ConfigParametersStore } from '../../stores/ConfigParametersStore';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

const ParameterEnforcer = observer((props) => {
  const parametersFetched = ConfigParametersStore.parameters !== null;
  if (!parametersFetched) {
    return (
      null
    );
  }
  return props.children;
});

ParameterEnforcer.propTypes = IPropTypes;

const enforceParameters = Component => (
  props => (
    <ParameterEnforcer>
      <Component {...props} />
    </ParameterEnforcer>
  )
);

export { enforceParameters };



// WEBPACK FOOTER //
// ./src/hocs/enforce-parameters/EnforceParameters.jsx